// Get Visits Analytics Use Case

import type {HomeAnalyticsRepository} from '../repository/HomeAnalyticsRepository';
import type {VisitsAnalytics} from '../models/homeAnalytics.model';

export class GetVisitsAnalyticsUseCase {
  constructor (private repository: HomeAnalyticsRepository) {}

  async execute (): Promise<VisitsAnalytics> {
    return this.repository.getVisitsAnalytics();
  }
}
